import React from "react";
import SearchBar from "../../../features/Users/Component/SearchBar";
import Buttons from "../button/Buttons";

function CardSection({
  children,
  cardTitle,
  rightButton,
  buttonClassName,
  titleButtonClick,
  buttonText,
  searchInput,
  searchInputName,
  textWithIcon,
  iconImg,
  handleChange,
  isButtonVisible,
}) {
  return (
    <div
      className={`card-section ${cardTitle ? "card-section-left" : ""}${
        searchInput && rightButton ? "card-section-between" : ""
      }${rightButton ? "card-button-only" : ""}`}
    >
      {(cardTitle || rightButton) && (
        <div className="card-top-title-btn">
          {cardTitle && <div className="section-title">{cardTitle}</div>}

          {searchInput && (
            <div className="search-input">
              <SearchBar
                searchText={searchInputName}
                handleChange={handleChange}
              />
            </div>
          )}

          {
            isButtonVisible && (

              rightButton && (
                <div className="btn-right-sec">
                  {/* Button to open the Add Craft modal */}
                  <Buttons
                    buttonTypeClassName={buttonClassName}
                    onClick={titleButtonClick}
                    buttonText={buttonText}
                    textWithIcon={textWithIcon}
                    imagePath={iconImg}

                  />
                </div>
              )
            )
          }
        </div>
      )}
      <div className="card-body-sec mt-3">{children}</div>
    </div>
  );
}

export default CardSection;
